import * as types from './mutations-types';
import { get, size, uniqueId } from 'lodash-es';
import { clientApi } from '@phoenix/clientApi';
import { closeModal, showModal } from '@phoenix/helpers/modal-helper';

const initialState = {
  suggestedAddress: {},
  addressInForm: {},
  addressIsSaving: false,
  randomFormId: null,
  shouldDisplayZipSearchForm: false,
  shouldDisplaySuggestions: false,
  suggestions: [],
  isLoadingSuggestions: false,
  suggestionsError: null,
};

const getters = {
  hasSuggestedAddress: (state) => size(state.suggestedAddress) > 0,
};

const actions = {
  clearAll({ state, commit, dispatch }) {
    if (size(state.suggestedAddress) > 0) {
      dispatch('clearSuggestion');
    }
    if (size(state.addressInForm) > 0) {
      commit(types.CUSTOMER_ADDRESS_FORM_SET_ADDRESS_IN_FORM);
    }
  },

  clearSuggestion({ commit }) {
    commit(types.CUSTOMER_ADDRESS_SUGGESTED_ADDRESSES_DELETE);
  },

  onAddressSavedFail({ commit, dispatch }, error) {
    dispatch('setAddressIsSaving', false);
    if (get(error, ['response', 'data', 'data', 'suggested_address'], null)) {
      commit(
        types.CUSTOMER_ADDRESS_FROM_SUGGESTED_ADDRESSES_LOADED_SUCCESS,
        error.response.data.data.suggested_address
      );
    }
  },

  openForm({ commit, dispatch }, { modalId = null, address = null }) {
    dispatch('clearAll');
    commit(types.CUSTOMER_ADDRESS_FORM_SET_ADDRESS_IN_FORM, address);
    commit(types.CUSTOMER_ADDRESS_FORM_SET_RANDOM_ID);

    if (modalId !== null) {
      showModal(modalId);
    }
  },

  closeFormModal({ dispatch }, modalId) {
    closeModal(modalId);
    dispatch('setAddressIsSaving', false);
  },

  setAddressIsSaving({ commit }, value) {
    commit(types.CUSTOMER_ADDRESS_FORM_SET_ADDRESS_IS_SAVING, value);
  },

  setShouldDisplayZipSearchForm({ commit }, value) {
    commit(types.CUSTOMER_ADDRESS_FORM_SET_SHOULD_DISPLAY_ZIP_SEARCH_FORM, value);
  },

  setShouldDisplaySuggestions({ commit }, value) {
    commit(types.CUSTOMER_ADDRESS_FORM_SET_SHOULD_DISPLAY_SUGGESTIONS, value);
  },

  async fetchSuggestions({ commit }, data) {
    commit(types.CUSTOMER_ADDRESS_FORM_SET_LOADING_SUGGESTIONS, true);
    commit(types.CUSTOMER_ADDRESS_FORM_SET_SHOULD_DISPLAY_SUGGESTIONS, true);

    try {
      const response = await clientApi.post(window.route('api.customer.address.suggestions'), data);
      commit(types.CUSTOMER_ADDRESS_FORM_SET_SUGGESTIONS, get(response, 'data.data.suggestions', []));
      commit(types.CUSTOMER_ADDRESS_FORM_SET_SUGGESTIONS_ERROR, null);
    } catch (error) {
      window.Phoenix.sentry.captureException(error);
      commit(types.CUSTOMER_ADDRESS_FORM_SET_SUGGESTIONS_ERROR, error.response.data.message);
    }

    commit(types.CUSTOMER_ADDRESS_FORM_SET_LOADING_SUGGESTIONS, false);
  },
};

const mutations = {
  [types.CUSTOMER_ADDRESS_FROM_SUGGESTED_ADDRESSES_LOADED_SUCCESS](state, suggestedAddress) {
    state.suggestedAddress = suggestedAddress;
  },

  [types.CUSTOMER_ADDRESS_SUGGESTED_ADDRESSES_DELETE](state) {
    state.suggestedAddress = [];
  },

  [types.CUSTOMER_ADDRESS_FORM_SET_ADDRESS_IN_FORM](state, address) {
    state.addressInForm = address
      ? address
      : {
          id: 0,
          default: false,
        };
  },

  [types.CUSTOMER_ADDRESS_FORM_SET_ADDRESS_IS_SAVING](state, value) {
    state.addressIsSaving = value;
  },

  [types.CUSTOMER_ADDRESS_FORM_SET_RANDOM_ID](state) {
    state.randomFormId = uniqueId('customer-address-form');
  },

  [types.CUSTOMER_ADDRESS_FORM_SET_SHOULD_DISPLAY_ZIP_SEARCH_FORM](state, value) {
    state.shouldDisplayZipSearchForm = value;
  },

  [types.CUSTOMER_ADDRESS_FORM_SET_SHOULD_DISPLAY_SUGGESTIONS](state, value) {
    state.shouldDisplaySuggestions = value;
  },

  [types.CUSTOMER_ADDRESS_FORM_SET_SUGGESTIONS](state, suggestions) {
    state.suggestions = suggestions;
  },

  [types.CUSTOMER_ADDRESS_FORM_SET_LOADING_SUGGESTIONS](state, isLoading) {
    state.isLoadingSuggestions = isLoading;
  },

  [types.CUSTOMER_ADDRESS_FORM_SET_SUGGESTIONS_ERROR](state, error) {
    state.suggestionsError = error;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
